<template>
  <div class="dashboardPage">
    <div style="margin-left: 22px;margin-bottom: 10px;font-size: 14px">
      <p style="margin-bottom: 10px;">更新时间：{{ update_time }}</p>
      <!-- <el-radio-group v-model="datatype" size="medium" @input="getdata">
        <el-radio-button label="全部" ></el-radio-button>
        <el-radio-button label="线上"   ></el-radio-button>
        <el-radio-button label="线下"    ></el-radio-button>

      </el-radio-group> -->
    </div>

    <div class="top">

      <div class="homeCardComponent cardbox" style="background-color: rgb(244, 247, 251);">

        <div class="top"><span class="fs22" style="color: rgb(27, 85, 175);">新增订单</span>
          <span class="today"
                style="color: rgb(27, 85, 175); border-color: rgb(201, 215, 236);">今日</span>
        </div>
        <div class="nums" style="color: rgb(27, 85, 175);">{{ top_data.v_order_now_num }}</div>
        <div class="footer">
          <div class="item"><span>昨日</span><span>{{ top_data.v_order_yesterday_num }}</span></div>
          <div class="item"><span>本周</span><span>{{ top_data.v_order_week_num }}</span></div>
          <div class="item"><span>本月</span><span>{{ top_data.v_order_month_num }}</span></div>
          <div class="item"><span>本年</span><span>{{ top_data.v_order_year_num }}</span></div>
        </div>
      </div>
      <div class="homeCardComponent cardbox" style="background-color: rgb(242, 246, 238);">
        <div class="top"><span class="fs22" style="color: rgb(66, 122, 10);">成交金额</span><span class="today"
                                                                                              style="color: rgb(66, 122, 10); border-color: rgb(207, 221, 192);">今日</span>
        </div>
        <div class="nums" style="color: rgb(66, 122, 10);">{{ top_data.v_totalamount_now_num }}</div>
        <div class="footer">

          <div class="item"><span>昨日</span><span>{{ top_data.v_totalamount_yesterday_num }}</span></div>
          <div class="item"><span>本周</span><span>{{ top_data.v_totalamount_week_num }}</span></div>
          <div class="item"><span>本月</span><span>{{ top_data.v_totalamount_month_num }}</span></div>
          <div class="item"><span>本年</span><span>{{ top_data.v_totalamount_year_num }}</span></div>
        </div>
      </div>
    </div>

    <!-- <h2>快捷导航</h2>
    <el-row :gutter="20">
      <el-col :span="6">
        <router-link to='/WaitStorehouse'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              待入库
              <span>{{ top_data.待入库 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/InStorehouse'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              入库审核
              <span>{{ top_data.入库审核 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/WaitDelivery'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              待出库 <span>{{ top_data.待出库 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/Delivery'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              出库审核 <span>{{ top_data.出库审核 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/newMemTrial'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              产品审核 <span>{{ top_data.产品审核 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/financialAaudit'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              财务审核 <span>{{ top_data.财务审核 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/fillorderprice'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              财务补差审核 <span>{{ top_data.财务补差审核 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/invoice'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              开票审核 <span>{{ top_data.开票审核 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>

      <el-col :span="6">
        <router-link to='/bindCompanyid'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              友商认证 <span>{{ top_data.友商认证 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>

      <el-col :span="6">
        <router-link to='/bindCompanyidforWXuser'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              用户企业认证 <span>{{ top_data.用户企业认证 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/freight'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              运费报价 <span>{{ top_data.运费报价 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/spotsalesApproval'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              现货销售审批 <span>{{ top_data.现货销售审批 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link to='/rechargeAudit'>
          <div class="grid-content bg-purple">
            <el-card shadow="hover">
              现金账号充值审批 <span>{{ top_data.现金账号充值审批 }}</span>
            </el-card>
          </div>
        </router-link>
      </el-col>
    </el-row> -->
    <h2>统计</h2>
    <el-row :gutter="20">

      <el-col :span="12">
        <div class="grid-content bg-purple">
          <el-card shadow="hover">
            每日订单数量
            <div id="main_num" style="height: 400px;width: 90%"></div>
          </el-card>
        </div>

      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <el-card shadow="hover">
            每日支付金额
            <div id="main_pay" style=" height: 400px;width: 90%"></div>
          </el-card>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  companyid, customuser,
  getScmInfo, UserPage
} from '../../static/API/API.js'
import * as echarts from 'echarts';

export default {
  data() {
    return {
      top_data: {
        "v_order_now_num": "0",
        "v_order_yesterday_num": "0",
        "v_order_year_num": "0",
        "v_order_week_num": "0",
        "v_order_month_num": "0",
        "v_user_now_num": "0",
        "v_user_yesterday_num": "0",
        "v_user_year_num": "0",
        "v_user_month_num": "0",
        "v_user_week_num": "0",

        "v_members_now_num": "0",
        "v_members_yesterday_num": "0",
        "v_members_year_num": "0",
        "v_members_week_num": "0",
        "v_members_month_num": "0",

        "v_totalamount_now_num": 0,
        "v_totalamount_yesterday_num": 0,
        "v_totalamount_year_num": "0",
        "v_totalamount_week_num": "0",
        "v_totalamount_month_num": "0",
        "待入库": "0",
        "入库审核": "0",
        "待出库": "0",
        "出库审核": "0",
        "产品审核": "0",
        "财务审核": "0",
        "财务补差审核": "0",
        "开票审核": "0",
        "友商认证": "0",
        "用户企业认证": "0",
        "运费报价": "0",
        "现货审批单": "0",
        "现金账号充值审批": "0"
      },
      mid_data1: [
        {
          "订单数量": 2,
          "下单时间": "2022-12-10"
        },
        {
          "订单数量": 3,
          "下单时间": "2022-12-13"
        },
        {
          "订单数量": 37,
          "下单时间": "2022-12-14"
        },
        {
          "订单数量": 12,
          "下单时间": "2022-12-15"
        },
        {
          "订单数量": 2,
          "下单时间": "2022-12-16"
        },
        {
          "订单数量": 11,
          "下单时间": "2022-12-17"
        },
        {
          "订单数量": 1,
          "下单时间": "2022-12-19"
        },
        {
          "订单数量": 11,
          "下单时间": "2022-12-21"
        },
        {
          "订单数量": 1,
          "下单时间": "2022-12-26"
        },
        {
          "订单数量": 1,
          "下单时间": "2022-12-27"
        },
        {
          "订单数量": 7,
          "下单时间": "2022-12-28"
        },
        {
          "订单数量": 3,
          "下单时间": "2022-12-29"
        },
        {
          "订单数量": 9,
          "下单时间": "2022-12-30"
        },
        {
          "订单数量": 3,
          "下单时间": "2023-01-05"
        },
        {
          "订单数量": 1,
          "下单时间": "2023-01-06"
        },
        {
          "订单数量": 3,
          "下单时间": "2023-01-07"
        },
        {
          "订单数量": 27,
          "下单时间": "2023-01-09"
        },
        {
          "订单数量": 36,
          "下单时间": "2023-01-10"
        },
        {
          "订单数量": 26,
          "下单时间": "2023-01-11"
        },
        {
          "订单数量": 30,
          "下单时间": "2023-01-12"
        },
        {
          "订单数量": 57,
          "下单时间": "2023-01-13"
        },
        {
          "订单数量": 9,
          "下单时间": "2023-01-14"
        },
        {
          "订单数量": 3,
          "下单时间": "2023-01-16"
        },
        {
          "订单数量": 1,
          "下单时间": "2023-01-17"
        },
        {
          "订单数量": 8,
          "下单时间": "2023-01-29"
        },
        {
          "订单数量": 12,
          "下单时间": "2023-01-30"
        },
        {
          "订单数量": 8,
          "下单时间": "2023-01-31"
        },
        {
          "订单数量": 7,
          "下单时间": "2023-02-01"
        },
        {
          "订单数量": 2,
          "下单时间": "2023-02-02"
        },
        {
          "订单数量": 4,
          "下单时间": "2023-02-04"
        },
        {
          "订单数量": 2,
          "下单时间": "2023-02-07"
        }
      ],
      mid_data2: [
        {
          "支付金额": "24100.00",
          "下单时间": "2022-12-14"
        },
        {
          "支付金额": "16000.00",
          "下单时间": "2022-12-16"
        },
        {
          "支付金额": "19150.00",
          "下单时间": "2022-12-21"
        },
        {
          "支付金额": "10980.00",
          "下单时间": "2022-12-28"
        },
        {
          "支付金额": "15990.00",
          "下单时间": "2022-12-29"
        },
        {
          "支付金额": "43550.00",
          "下单时间": "2023-01-05"
        },
        {
          "支付金额": "156842.00",
          "下单时间": "2023-01-11"
        },
        {
          "支付金额": "1122708.00",
          "下单时间": "2023-01-12"
        },
        {
          "支付金额": "2035807.20",
          "下单时间": "2023-01-13"
        },
        {
          "支付金额": "386796.00",
          "下单时间": "2023-01-14"
        },
        {
          "支付金额": "123502.00",
          "下单时间": "2023-01-17"
        },
        {
          "支付金额": "576868.00",
          "下单时间": "2023-01-29"
        },
        {
          "支付金额": "136480.00",
          "下单时间": "2023-01-30"
        },
        {
          "支付金额": "67980.00",
          "下单时间": "2023-01-31"
        },
        {
          "支付金额": "42700.00",
          "下单时间": "2023-02-01"
        },
        {
          "支付金额": "133442.00",
          "下单时间": "2023-02-02"
        },
        {
          "支付金额": "411061.00",
          "下单时间": "2023-02-04"
        }
      ],
      update_time: '',
      datatype:'线上'
    }
  },
  methods: {
    getdata() {
      var _this = this
      let params = new URLSearchParams();
      params.append('datatype', this.datatype);
      this.$axios.get(getScmInfo,{params}).then(res => {
        if (res.data.code == '200') {
          _this.top_data = res.data['top_data']
          _this.mid_data1 = res.data['mid_data1']
          _this.mid_data2 = res.data['mid_data2']
          _this.update_time = res.data['update_time']
          _this.initechart_num()
          _this.initechart_pay()
        }
      })


      Date.prototype.Format = function (fmt) { //author: meizz
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
      }
    },
    initechart_num() {
      var _this=this
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      let _xAxis=this.fgetDatArr(start,end)
      let series= _xAxis.map(function (item){
        var _data=0
        for (let i = 0; i < _this.mid_data1.length; i++) {
          if(_this.mid_data1[i].下单时间==item){
            _data= _this.mid_data1[i].订单数量
            continue
          }
        }
        return _data
      })
      var chartDom = document.getElementById('main_num');
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: _xAxis
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['订单量']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '订单量',
            data: series,
            type: 'line',
            smooth: true
          }
        ]
      };
      option && myChart.setOption(option);
    },
    initechart_pay() {
      var _this=this
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      let _xAxis=this.fgetDatArr(start,end)
      let series= _xAxis.map(function (item){
        var _data=0
        for (let i = 0; i < _this.mid_data2.length; i++) {
          if(_this.mid_data2[i].下单时间==item){
            _data= _this.mid_data2[i].支付金额
            continue
          }
        }
        return _data
      })
      var chartDom = document.getElementById('main_pay');
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: _xAxis
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['支付金额']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '支付金额',
            data: series,
            type: 'line',
            smooth: true
          }
        ]
      };
      option && myChart.setOption(option);
    },
    fgetDatArr(start, end) {
      let dateList = [];
      var startTime = new Date(start);;
      var endTime = new Date(end);;

      while ((endTime.getTime() - startTime.getTime()) >= 0) {
        var year = startTime.getFullYear();
        var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
        var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
         dateList.push(year + "-" + month + "-" + day);
        // dateList.push(month + "/" + day);
        startTime.setDate(startTime.getDate() + 1);
      }
      return dateList;
    },
    getpagesee() {
      var _this=this
      let params = new URLSearchParams()
      if (sessionStorage.getItem('department') == '管理部' && companyid ==0) {
        params.append('all', 'total')
      }
      params.append('user_id', sessionStorage.getItem('user_id'))
      this.$axios.get(UserPage, {
        params
      }).then(res => {
        let brr = res.data;
        let arr = [];
        brr.forEach((e) => {
          let obj = {
            id: e.id,
            caidan: e.name,
            icon: e.des,
            xiala: []
          };
          if (e.parent_id == 0) {
            arr.push(obj);
          }
        });
        arr.forEach((e) => {
          brr.map((f) => {
            f.child.map((c) => {
              let obj = {
                name: c.page,
                navItem: c.name
              };
              // console.log(f.parent_id == e.id)
              if (c.parent_id == e.id) {
                e.xiala.push(obj);
              }
            })

          });
        });


        //如果当前没有权限，跳转到登录页
        // var indexUrl=window.location.pathname

        // console.log(indexUrl,'222222222');

        // var boollogin=false
        // arr.forEach((e) => {
        //   brr.map((f) => {
        //     f.child.map((c) => {
        //       console.log(c.page);
        //       if (c.page.indexOf(indexUrl)>-1) {
        //         boollogin=true
        //       }
        //     })

        //   });
        // });
        // console.log(boollogin)
        // if(!boollogin){
        //   _this.$router.replace({
        //     path: '/'
        //   });
        //   sessionStorage.clear()
        //   location.reload();
        // }
      })
    },

  },
  mounted() {
    //检查权限

    this.getdata()

    this.getpagesee()
  },

}

</script>

<style scoped>

.dashboardPage .top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.dashboardPage .top .cardbox {
  margin: 0 10px;
  cursor: default;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.dashboardPage h2{
  margin: 15px 0;
  font-size: 18px;
  font-weight: 600;
}
.homeCardComponent {
  padding: 15px;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 200px;
  min-height: 200px;
  border-radius: 16px;
}

.homeCardComponent .top {
  font-size: 22px;
  margin: 12px 0 12px 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.homeCardComponent .nums {
  margin: 8px;
  font-size: 48px;
}

.homeCardComponent .footer {
  height: 115px;
  font-size: 16px;
  padding: 12px 0;
  border-radius: 8px;
  background-color: hsla(0, 0%, 100%, .8);
  -webkit-box-shadow: 0 10px 20px 1px rgb(27 85 175 / 5%);
  box-shadow: 0 10px 20px 1px rgb(27 85 175 / 5%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}

.homeCardComponent .footer .item {
  margin: 0 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #333;
}

.homeCardComponent .footer .item .precent .redP {
  color: #d04a41;
}

.homeCardComponent .footer .item .precent .up {
  position: relative;
  top: -12px;
  border-color: transparent transparent #d04a41 transparent;
}

.homeCardComponent .top .today {
  font-size: 14px;
  padding: 8px 16px;
  border: 1px solid;
  border-radius: 4px;
}

.grid-content.bg-purple {
  padding-bottom: 10px;
  cursor: pointer;
}

.grid-content.bg-purple span {
  float: right;
  color: rgb(244, 95, 32);
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard.vue